import { render, staticRenderFns } from "./Sprjtype.vue?vue&type=template&id=9476cb9e&scoped=true"
import script from "./Sprjtype.vue?vue&type=script&lang=js"
export * from "./Sprjtype.vue?vue&type=script&lang=js"
import style0 from "./Sprjtype.vue?vue&type=style&index=0&id=9476cb9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9476cb9e",
  null
  
)

export default component.exports